import { Immutable } from "immer";
import React from "react";

import type { DetailBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { getSpacingClasses } from "../spacing";

import styles from "./index.module.scss";

type Props = Immutable<{
    value: Value;
}>;

export const DetailBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const showHeading = !v.hide_heading && !!v.heading;
    const details = v.details ?? [];
    return (
        <section
            className={concatClassNames([
                "detail",
                styles.detailBlock,
                v.background_style ?? "",
                getSpacingClasses(v.spacing),
            ])}
        >
            {showHeading && (
                <header>
                    <RichTextBlock value={v.heading ?? ""} />
                </header>
            )}
            {details.map((item, i) => (
                <RichTextBlock key={i} value={item ?? ""} />
            ))}
        </section>
    );
};
